import { useState } from "react"
import { Div, Col, Row, Text } from "atomize"
import { toast } from "react-toastify"
import PrimaryButton from "../buttons/PrimaryButton"
import SecondaryButton from "../buttons/SecondaryButton"
import { theme } from "../settings/config"
import Container from "../atoms/Container"
import { archivePlayer, restorePlayer } from "../utils/firestore.utils"
import { getPlayerFullName, isArchivedPlayer } from "../utils/func.utils"

// L'allievo non si elimina mai: archiviarlo lo toglie dalle liste ma lascia
// intatte le lezioni e i pagamenti in cui compare
export function ArchivePlayerModal({ closeModal, playerData }) {
	const isArchived = isArchivedPlayer(playerData)

	const [isSaving, setSavingState] = useState(false)

	const handleConfirm = async () => {
		setSavingState(true)
		try {
			if (isArchived) {
				await restorePlayer(playerData.playerID)
				toast.success("Allievo riportato tra gli attivi 🎾", { position: "top-center" })
			} else {
				await archivePlayer(playerData.playerID)
				toast.success("Allievo archiviato", { position: "top-center" })
			}
			closeModal()
		} catch (error) {
			console.error("Errore archiviazione allievo:", error)
			toast.error("Non sono riuscito ad aggiornare l'allievo", { position: "top-center" })
		} finally {
			setSavingState(false)
		}
	}

	return (
		<Container>
			<Div
				d={"flex"}
				justify={"space-between"}
				m={{ b: "0.5rem" }}
				textWeight="bold"
				textSize="title"
				textColor={theme === "light" ? "text" : "text_alt"}>
				{isArchived
					? `Vuoi riattivare ${getPlayerFullName(playerData)}?`
					: `Vuoi archiviare ${getPlayerFullName(playerData)}?`}
			</Div>
			<Text textColor={theme.colors.gunmetal}>
				{isArchived
					? "Tornerà tra gli allievi attivi e potrai inserirlo di nuovo nelle lezioni."
					: "Sparirà dalla lista e non potrai più inserirlo in una lezione, ma le lezioni e i pagamenti già registrati restano al loro posto. Puoi riattivarlo quando vuoi dal filtro archiviati."}
			</Text>
			<Div m={{ x: "1rem" }}>
				<Row m={{ t: "1rem" }}>
					<Col p="0">
						<SecondaryButton
							m="auto"
							textColor={theme.colors.gunmetal}
							text={
								isSaving
									? isArchived
										? "Sto riattivando..."
										: "Sto archiviando..."
									: "Sì, confermo!"
							}
							textSize="subheader"
							disabled={isSaving}
							action={handleConfirm}
						/>
					</Col>
					{!isSaving && (
						<Col p="0">
							<PrimaryButton
								m="auto"
								bg={theme.colors.gunmetal_fill}
								textColor="white"
								textSize="subheader"
								text="No, macchè!"
								action={closeModal}
							/>
						</Col>
					)}
				</Row>
			</Div>
		</Container>
	)
}

export default ArchivePlayerModal
